export default __webpack_public_path__ + "static/media/hsbc-color.fd26a8a2.svg";